export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_05_RSeries_end.02aade50.jpg";